import * as Yup from "yup";

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;
export const CURRENT_PASSWORD_MAX_LENGTH = 256;

export const PASSWORD_POLICY_MESSAGE =
  "Your password must be 8 to 128 characters and include at least one number and one special character.";

export const PASSWORD_REQUIRED_MESSAGE = "You must provide a password.";
export const CURRENT_PASSWORD_REQUIRED_MESSAGE =
  "You must provide your current password.";
export const CURRENT_PASSWORD_MAX_LENGTH_MESSAGE =
  "Your current password can't be more than 256 characters.";

const hasNumber = /\d/;
const hasSpecialCharacter = /[^A-Za-z0-9]/;

export const buildNewPasswordSchema = () =>
  Yup.string()
    .required(PASSWORD_REQUIRED_MESSAGE)
    .min(PASSWORD_MIN_LENGTH, PASSWORD_POLICY_MESSAGE)
    .max(PASSWORD_MAX_LENGTH, PASSWORD_POLICY_MESSAGE)
    .matches(hasNumber, PASSWORD_POLICY_MESSAGE)
    .matches(hasSpecialCharacter, PASSWORD_POLICY_MESSAGE);

export const buildOptionalNewPasswordSchema = () =>
  buildNewPasswordSchema()
    .transform((value) => (value === "" ? undefined : value))
    .notRequired();

export const buildCurrentPasswordSchema = () =>
  Yup.string()
    .required(CURRENT_PASSWORD_REQUIRED_MESSAGE)
    .max(CURRENT_PASSWORD_MAX_LENGTH, CURRENT_PASSWORD_MAX_LENGTH_MESSAGE);
